import React, {useState, useEffect, useRef } from 'react'
import Button from '../../templates/Button';
import InputField from '../../templates/InputField'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { addVehicle, getVehicleById, updateVehicleById } from '../../../redux_store/vehicles/vehicle_thunk';
import { SUCCESS, FAIL, LOADING } from '../../../redux_store/actionTypes';
import toast from '../../templates/ToastMessage'
import LoadingModal from '../../templates/modals/LoadingModal';
import { convertFromCedisToPesewas, convertFromPesewasToCedis, displayFile } from '../../../utils';

const ManageVehicles = () => {
  const [details, setDetails] = useState({});
  const dispatch = useDispatch();
  const [state, setState] = useState('create');
  const params = useParams();
  const navigator = useNavigate();
  const { status, message, vehicles: vehicle } = useSelector((state)=>state.vehicle);
  const imageRef = useRef(null);
  const vehicleimgRef = useRef(null);

  useEffect(()=>{
    if(params.id){
      setState('edit');
      dispatch(getVehicleById(params.id));
    }
    // eslint-disable-next-line
  }, [params.id]);

  useEffect(()=>{
    if (vehicle) {
      console.log('vehicle:: ',vehicle);
      setDetails({
        ...vehicle,
        base_fee: convertFromPesewasToCedis(vehicle.base_fee)
      });
    }
  }, [vehicle]);

  useEffect(()=>{
    if(status === FAIL){
      toast({message, status});
    }else if(status === SUCCESS){
      navigator('/vehicles');
    }
    // eslint-disable-next-line
  }, [status]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if(isNaN(details.base_fee)){
      return toast({message: 'Base fee should be a number', status: 'fail'});
    }
    if(state === 'edit'){
      dispatch(updateVehicleById({
        id: params.id,
        details: {
          ...details,
          base_fee: convertFromCedisToPesewas(details.base_fee)}
      }));
    }else{
      dispatch(addVehicle({
        ...details,
        base_fee: convertFromCedisToPesewas(details.base_fee)
      }));
    }
  }

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setDetails({...details, [name]:value});
  }

  const handleImageSelect = () => {
    const image = imageRef.current;
    image.click();
    image.addEventListener('change', (e)=>{
      setDetails({...details, image: image.files[0]});
      displayFile(image.files[0], vehicleimgRef.current);
    })
  }

  return (
    <form onSubmit={handleFormSubmit} className='grid gap-y-5 gap-x-8 py-10 px-16 grid-cols-2 bg-white shadow-md rounded'>
      {status === LOADING && <LoadingModal message={'Please wait...'} />}
      <input type={'file'} ref={imageRef} name="profile_pic" hidden />
      <div className='border flex flex-col border-gray-400 shadow-md h-48 w-1/3 col-span-2'>
        <div ref={vehicleimgRef} className="w-full h-full"></div>
        <button type='button' onClick={handleImageSelect} className='w-full z-10 bg-gray-200 py-1'>select image</button>
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Vehicle Type</p>
        <InputField 
          type={'text'}
          name="vehicle_types"
          isRequired={true}
          onChange={handleInputChange}
          value={details.vehicle_types}
          placeholder="Enter Vehicle Type" 
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Base Fee</p>
        <InputField 
          type={'text'}
          name="base_fee"
          isRequired={true}
          onChange={handleInputChange}
          value={details.base_fee}
          placeholder="Enter Base fee" 
        />
      </div>
      <div className='col-span-2'>
        <Button
          type="submit"
          label={state === 'edit' ? 'Update' : 'Submit'}
          width="w-full"
          bgColor={'wayrideBgColor'}
        />
      </div>
    </form>
  )
}

export default ManageVehicles